import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-400' : 'text-dark-500';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-sm bg-gradient-to-br from-athletic-500 to-athletic-700 flex items-center justify-center shadow-button skew-x-[-6deg] group-hover:skew-x-0 transition-transform">
          <span className="font-display font-bold text-white text-xl tracking-tight leading-none skew-x-[6deg] group-hover:skew-x-0 transition-transform">IE</span>
        </div>
        <span className="absolute -bottom-1 -right-1 w-4 h-4 rounded-sm bg-dark-900 border border-white flex items-center justify-center">
          <span className="font-display font-bold text-athletic-500 text-[9px] leading-none">T</span>
        </span>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-bold text-[1.35rem] uppercase tracking-tight ${textColor} transition-colors`}>
          Iron <span className="text-athletic-600">Edge</span> Tools
        </span>
        <span className={`text-[10px] font-bold uppercase tracking-[0.3em] mt-1 ${subTextColor} transition-colors`}>
          Hardware &amp; Power Tools
        </span>
      </div>
    </Link>
  );
};

export default Logo;
